module.exports = __webpack_public_path__ + "img/concrete-hole-decal-21.93d3f269.png";